// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const arrayMoveMutate = (array, from, to) => {
  const startIndex = to < 0 ? array.length + to : to;
  const item = array.splice(from, 1)[0];
  array.splice(startIndex, 0, item);
};

export const arrayMove = (array, from, to) => {
  const arr = array.slice();
  arrayMoveMutate(arr, from, to);
  return arr;
};
